<template>
  <div class="externalArea">
    <div class="middleArea">
      <div class="internalArea">
        <div class="icon">
          <van-icon name="search" />
        </div>
        <div class="input">
          <input type="text" v-model="value" placeholder="请输入搜索关键词">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "newInput",
  components: {},
  props: ['value'],
  data() {
    return {}
  },
  methods: {},
  created() {

  },
  mounted() {

  },
  computed: {},
  watch: {}
}
</script>

<style lang="scss" scoped>
  .externalArea{
    padding:20px 24px;
    .middleArea{
      padding-left:24px;
      background-color: #f7f8fa;
      border-radius: 4px;
      .internalArea{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 10px 16px 10px 0;
        .icon{
          margin-right:8px;
          font-size:32px;
          display: flex;
          align-items: center;
        }
        .input{
          &>input{
            background-color: transparent;
            border: 0;
            color: #323233;
            line-height:48px;
            font-size:30px;
          }
        }
      }
    }
  }
</style>
